const StateJS = require('@steelbreeze/state');
const EventEmitter = require('events').EventEmitter;
const Enum = require('./enums');
const Event = require('./events');

/*
 * Definition for type : Statuses
 */

function Statuses(name, root) {
  this.bus = (root === null) ? new EventEmitter() : root.bus;
  this.name = name;
  this.root = (root === null) ? this : root;
  this.ready = false;

  this.build(name);
}

Statuses.prototype.build = function (session) {
  /* State machine (states and regions) */
  /* Building root component */
  this._statemachine = new StateJS.State('default_statemachine');
  const _initial_Statuses = new StateJS.PseudoState('_initial', this._statemachine, StateJS.PseudoStateKind.Initial);
  const Statuses_null_default = new StateJS.State('default', this._statemachine);
  _initial_Statuses.to(Statuses_null_default);
  Statuses_null_default.on(Event.MediaError).when((mediaError) => mediaError.port === 'input' && mediaError.type === 'mediaError').effect((mediaError) => {
    const mediaError_var = `media-${mediaError.err}`;
    this.onMediaError(mediaError_var);
    this.sendOverWebsocket({
      userAgent: this.Statuses_userAgent_var, healthProviderId: this.Statuses_healthProviderId_var, type: 'error', errorType: mediaError_var, camera: this.Statuses_cameraName_var, timestamp: this.timestamp(),
    });
  });
  Statuses_null_default.on(Event.Unrecoverable).when((unrecoverable) => unrecoverable.port === 'input' && unrecoverable.type === 'unrecoverable').effect((unrecoverable) => {
    this.onChange(Enum.StatusTypes_ENUM.UNRECOVERABLE, unrecoverable.isEnabled);
    this.sendOverWebsocket({
      healthProviderId: this.Statuses_healthProviderId_var, type: 'status', statusType: 'unrecoverable', camera: this.Statuses_cameraName_var, status: unrecoverable.isEnabled, timestamp: this.timestamp(),
    });
  });
  Statuses_null_default.on(Event.Duration).when((duration) => duration.port === 'input' && duration.type === 'duration').effect((duration) => {
    this.onValueChange(duration.status, duration.duration);
    this.sendOverWebsocket({
      healthProviderId: this.Statuses_healthProviderId_var, type: 'duration', durationType: duration.status, duration: duration.duration, camera: this.Statuses_cameraName_var, timestamp: this.timestamp(),
    });
  });
  Statuses_null_default.on(Event.WebsocketStatus).when((websocketStatus) => websocketStatus.port === 'input' && websocketStatus.type === 'websocketStatus').effect((websocketStatus) => {
    this.onWebsocketStatusChange(websocketStatus.status);
  });
  Statuses_null_default.on(Event.Broken).when((broken) => broken.port === 'input' && broken.type === 'broken').effect((broken) => {
    this.onChange(Enum.StatusTypes_ENUM.BROKEN, broken.isEnabled);
    this.sendOverWebsocket({
      healthProviderId: this.Statuses_healthProviderId_var, type: 'status', statusType: 'broken', camera: this.Statuses_cameraName_var, status: broken.isEnabled, timestamp: this.timestamp(),
    });
  });
  Statuses_null_default.on(Event.Waiting).when((waiting) => waiting.port === 'input' && waiting.type === 'waiting').effect((waiting) => {
    this.onChange(Enum.StatusTypes_ENUM.WAITING, waiting.isEnabled);
    this.sendOverWebsocket({
      healthProviderId: this.Statuses_healthProviderId_var, type: 'status', statusType: 'waiting', camera: this.Statuses_cameraName_var, status: waiting.isEnabled, timestamp: this.timestamp(),
    });
  });
  Statuses_null_default.on(Event.Stalled).when((stalled) => stalled.port === 'input' && stalled.type === 'stalled').effect((stalled) => {
    this.onChange(Enum.StatusTypes_ENUM.STALLED, stalled.isEnabled);
    this.sendOverWebsocket({
      healthProviderId: this.Statuses_healthProviderId_var, type: 'status', statusType: 'isStalled', camera: this.Statuses_cameraName_var, status: stalled.isEnabled, timestamp: this.timestamp(),
    });
  });
  Statuses_null_default.on(Event.TechnicalError).when((technicalError) => technicalError.port === 'input' && technicalError.type === 'technicalError').effect((technicalError) => {
    this.onTechnicalError(technicalError.err);
    this.sendOverWebsocket({
      userAgent: this.Statuses_userAgent_var, healthProviderId: this.Statuses_healthProviderId_var, type: 'error', errorType: technicalError.err, camera: this.Statuses_cameraName_var, timestamp: this.timestamp(),
    });
  });
  Statuses_null_default.on(Event.Loading).when((loading) => loading.port === 'input' && loading.type === 'loading').effect((loading) => {
    this.onChange(Enum.StatusTypes_ENUM.LOADING, loading.isEnabled);
    this.sendOverWebsocket({
      healthProviderId: this.Statuses_healthProviderId_var, type: 'status', statusType: 'loading', camera: this.Statuses_cameraName_var, status: loading.isEnabled, timestamp: this.timestamp(),
    });
  });
  Statuses_null_default.on(Event.AutoRestartCount).when((autoRestartCount) => autoRestartCount.port === 'input' && autoRestartCount.type === 'autoRestartCount').effect((autoRestartCount) => {
    this.onValueChange(Enum.StatusTypes_ENUM.RESTARTS, autoRestartCount.count);
    this.sendOverWebsocket({
      healthProviderId: this.Statuses_healthProviderId_var, type: 'counter', counterType: 'autoRestartCount', camera: this.Statuses_cameraName_var, count: autoRestartCount.count, timestamp: this.timestamp(),
    });
  });
  Statuses_null_default.on(Event.WaitedTooLong).when((waitedTooLong) => waitedTooLong.port === 'input' && waitedTooLong.type === 'waitedTooLong').effect((waitedTooLong) => {
    this.onChange(Enum.StatusTypes_ENUM.WAITEDTOOLONG, waitedTooLong.isEnabled);
    this.sendOverWebsocket({
      healthProviderId: this.Statuses_healthProviderId_var, type: 'status', statusType: 'waitedTooLong', camera: this.Statuses_cameraName_var, status: waitedTooLong.isEnabled, timestamp: this.timestamp(),
    });
  });
  Statuses_null_default.on(Event.Delayed).when((delayed) => delayed.port === 'input' && delayed.type === 'delayed').effect((delayed) => {
    this.onChange(Enum.StatusTypes_ENUM.DELAYED, delayed.isEnabled);
    this.sendOverWebsocket({
      healthProviderId: this.Statuses_healthProviderId_var, type: 'status', statusType: 'delayed', camera: this.Statuses_cameraName_var, status: delayed.isEnabled, timestamp: this.timestamp(),
    });
  });
  Statuses_null_default.on(Event.Unavailable).when((unavailable) => unavailable.port === 'input' && unavailable.type === 'unavailable').effect((unavailable) => {
    this.onChange(Enum.StatusTypes_ENUM.UNAVAILABLE, unavailable.isEnabled);
    this.sendOverWebsocket({
      healthProviderId: this.Statuses_healthProviderId_var, type: 'status', statusType: 'unavailable', camera: this.Statuses_cameraName_var, status: unavailable.isEnabled, timestamp: this.timestamp(),
    });
  });
};
Statuses.prototype.timestamp = function () {
  return Date.now();
};

Statuses.prototype.sendOverWebsocket = function (Statuses_sendOverWebsocket_payload_var) {
  this.bus.emit('wslog', new Event.Log_WebsocketStreamMsg(this.name, 'wslog', (JSON.stringify(Statuses_sendOverWebsocket_payload_var))));
};

Statuses.prototype.onChange = function (Statuses_onChange_type_var, Statuses_onChange_status_var) {};

Statuses.prototype.onValueChange = function (Statuses_onValueChange_type_var, Statuses_onValueChange_value_var) {};

Statuses.prototype.onWebsocketStatusChange = function (Statuses_onWebsocketStatusChange_status_var) {};

Statuses.prototype.onTechnicalError = function (Statuses_onTechnicalError_err_var) {};

Statuses.prototype.onMediaError = function (Statuses_onMediaError_err_var) {};

Statuses.prototype._stop = function () {
  this.root = null;
  this.ready = false;
  this.stopped = true;
};

Statuses.prototype._delete = function () {
  this._statemachine = null;
  this._null_instance = null;
  this.bus.removeAllListeners();
};

Statuses.prototype._init = function () {
  this._null_instance = new StateJS.Instance('null_instance', this._statemachine);
  this.ready = true;
};

Statuses.prototype._receive = function (msg) {
  if (this.ready) {
    this._null_instance.evaluate(msg);
  } else if (!this.stopped) {
    setTimeout(() => this._receive(msg), 4);
  }
};

Statuses.prototype.toString = function () {
  let result = `instance ${this.name}:${this.constructor.name}\n`;
  result += `\n\tuserAgent = ${this.Statuses_userAgent_var}`;
  result += `\n\tcameraName = ${this.Statuses_cameraName_var}`;
  result += `\n\thealthProviderId = ${this.Statuses_healthProviderId_var}`;
  result += '';
  return result;
};

module.exports = Statuses;
